module.exports = __webpack_public_path__ + "static/wimbledon-02-f5c12ed2ab3cdd6262715e304b81ed6f.jpg";